const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export default {
  data() {
    return {
      valid: false,
      profile: {},
      rules: {
        required: value => !!value || 'Поле должно быть заполнено',
        email: value => pattern.test(value) || 'Поле E-mail заполнено с ошибками',
      },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    isAuthenticated() {
      return this.$store.getters.isAuthenticated;
    },
    loading() {
      return this.$store.state.loading;
    },
    settings() {
      return this.$store.state.settings;
    },
  },
  methods: {
    createUser() {
      this.profile = { ...this.user };

      if (this.profile.birthday_on) {
        this.birthday_on = this.parseDate(this.profile.birthday_on);
      }
    },
    profileSubmit() {
      const app = this;
      if (this.$refs.form.validate() && this.isAuthenticated) {
        const profile = {
          profile_id: app.profile.profile_id,
          birthday_on: app.birthday_on,
          gender: app.profile.gender,
          address: app.profile.address,
          phone_mobile_local: app.profile.phone_mobile,
          phone_local: app.profile.phone,
          email: app.profile.email,
        };
        app.$store.getters.axl.post('profiles/api/auth/profile-edit', profile)
          .then(async () => {
            app.$store.dispatch('ShowInfo', 'Ваш профиль был успешно обновлён');
            await app.$store.dispatch('GetProfile');
            app.$router.push({ name: 'dashboard' });
          })
          .catch((error) => {
            app.$store.dispatch('HandleError', error);
          });
      } else {
        app.$store.dispatch('HandleError', 'Ошибка отправки формы');
      }
    },
  },
  mounted() {
    if (this.isAuthenticated) {
      this.$store.dispatch('eps/GetOrders', this.user.profile_id);
      this.createUser();
    }
  },
};
